import { render, staticRenderFns } from "./item_prolist.vue?vue&type=template&id=74877894&scoped=true&"
import script from "./item_prolist.vue?vue&type=script&lang=js&"
export * from "./item_prolist.vue?vue&type=script&lang=js&"
import style0 from "./item_prolist.vue?vue&type=style&index=0&id=74877894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74877894",
  null
  
)

export default component.exports